<template>
  <div>
    <PageAllow controller="OrderProfit" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="overflow-y-scroll fill-content-height">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <!-- 订单编号 -->
              <SearcherKeyword
                ref="order_code"
                v-model="options.order_code"
                @text="codeKeyword = $event"
                unclearable
                :label="$t('orderProfitDetail.code_keyword')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 导出 按钮 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="exportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("orderProfitAnalyze.Export.excel") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 分类 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterialCategoriesWithDescendants
                    v-model="materialCategorySelected"
                  />
                </v-col>
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="keyword"
                    v-model="options.keyword"
                    @text="orderProfitKeyword = $event"
                    :label="$t('orderProfitDetail.material_keyword')"
                  />
                </v-col>
                <!-- 分组 -->
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="
                    settings && settings.report_hide_search_district_tree == 2
                  "
                >
                  <SearcherDistrictsWithDescendants
                    v-model="DistrictsSelected"
                    :label="
                      $t('shopDailyReports.shopDistricts', [$consts.shopName()])
                    "
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="order_profit_analyze"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <!-- 合计 -->
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td colspan="6">
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ sale_total | formatMoney }}</span
                  >
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ cost_total | formatMoney }}</span
                  >
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ profit_total | formatMoney }}</span
                  >
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ profit_total_rate | formatTwoDot(true)
                    }}{{ $t("Global.rate") }}</span
                  >
                </td>
                <!-- <td></td> -->
              </tr>
              <!-- 小屏幕 -->
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("materialProfitAnalyze.Fields.sale_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}{{ sale_total | formatMoney }}
                  </div>
                </td>

                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("materialProfitAnalyze.Fields.cost_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}{{ cost_total | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("orderProfitAnalyze.Fields.profit_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ profit_total | formatMoney }}
                  </div>
                </td>

                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("orderProfitAnalyze.Fields.profit_total_rate") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ profit_total_rate | formatTwoDot(true)
                    }}{{ $t("Global.rate") }}
                  </div>
                </td>
              </tr>
            </template>

            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.standard_name="{ item }">
              <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                {{ item.standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else>
                {{ item.standard_name }}
              </span>
            </template>
            <!-- 数量 -->
            <template v-slot:item.default_out_num="{ item }">
              <span v-if="item.default_out_num">
                {{ item.default_out_num | formatTwoDot }}
              </span>
              <span v-if="item.default_out_num == null">
                {{ item.confirm_num | formatTwoDot }}
              </span>
            </template>
            <!-- 单位 -->
            <template v-slot:item.unit="{ item }">
              <span v-if="item.default_out_num">
                {{ item.default_unit }}
              </span>
              <span v-if="item.default_out_num == null">
                {{ item.unit }}
              </span>
            </template>

            <!-- 毛利率 -->
            <template v-slot:item.profit_rate="{ item }">
              {{ item.profit_rate | formatTwoDot(true) }}{{ $t("Global.rate") }}
            </template>
            <!-- 成本 -->
            <template v-slot:item.cost_total="{ item }">
              {{ $t("Global.money") }}{{ item.cost_total | formatMoney }}
            </template>
            <!-- 毛利 -->
            <template v-slot:item.profit_total="{ item }">
              {{ $t("Global.money") }}{{ item.profit_total | formatMoney }}
            </template>
            <!-- 售价s s -->
            <template v-slot:item.sale_total="{ item }">
              {{ $t("Global.money") }}{{ item.sale_total | formatMoney }}
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import OrderProfitAnalyze from "@/api/order_profit_analyze";
import SearcherMaterialCategoriesWithDescendants from "@/components/plugins/SearcherMaterialCategoriesWithDescendants";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";

const defaultOptions = {
  district_ids: [],
};

export default {
  data: () => ({
    order_profit_analyze: [],
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    loading: false,
    profit_total_rate: 0,
    profit_total: 0,
    cost_total: 0,
    sale_total: 0,
    materialCategorySelected: [],
    orderProfitKeyword: "",
    codeKeyword: "",
    DistrictsSelected: [],
  }),
  components: {
    Breadcrumbs,
    PageAllow,
    SearcherMaterialCategoriesWithDescendants,
    SearcherKeyword,
    SearcherDistrictsWithDescendants,
  },

  computed: {
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.profitAnalyze"),
          disabled: false,
          href: "/order-profit",
        },
        {
          text: i18n.t("Nav.orderProfit"),
          disabled: true,
        },
      ];
      // if(this.$route.params.code){
      //     items.push({
      //         text:this.$route.params.code,
      //         disabled:false,
      //         accent:true,
      //     });
      // }
      return items;
    },

    headers: () => [
      {
        text: i18n.t("orderProfitDetail.Fields.material_code"),
        align: "start",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("orderProfitDetail.Fields.material_name"),
        align: "start",
        sortable: false,
        value: "material_name",
      },
      {
        text: i18n.t("orderProfitDetail.Fields.standard_name"),
        align: "start",
        sortable: false,
        value: "standard_name",
      },
      {
        text: i18n.t("orderProfitDetail.Fields.category_name"),
        align: "start",
        sortable: false,
        value: "category_name",
      },
      // 数量
      {
        text: i18n.t("orderProfitDetail.Fields.default_out_num"),
        align: "end",
        sortable: false,
        value: "default_out_num",
      },
      // 单位
      {
        text: i18n.t("orderProfitDetail.Fields.unit"),
        align: "start",
        sortable: false,
        value: "unit",
      },
      // 售价
      {
        text: i18n.t("orderProfitDetail.Fields.sale_total"),
        align: "end",
        sortable: false,
        value: "sale_total",
      },
      // 成本
      {
        text: i18n.t("orderProfitDetail.Fields.cost_total"),
        align: "end",
        sortable: false,
        value: "cost_total",
      },
      // 毛利
      {
        text: i18n.t("orderProfitDetail.Fields.profit_total"),
        align: "end",
        sortable: false,
        value: "profit_total",
      },
      //毛利率
      {
        text: i18n.t("orderProfitDetail.Fields.profit_rate"),
        align: "end",
        sortable: false,
        value: "profit_rate",
      },
    ],

    ...mapState(["districtID", "settings"]),
  },

  mounted() {
    this.$store.commit("districtID", 0);
    this.$store.commit(
      "searchDistrict",
      this.settings && this.settings.report_hide_search_district_tree == 1
        ? true
        : false
    );
    this.$commonUtils
      .loadOptions("order_profit_analyze", [
        "materialCategorySelected",
        "DistrictsSelected",
        // "shopsSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            data.options.order_code = this.$route.params.code;
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "materialCategorySelected":
                this.materialCategorySelected = selected.value;
                break;
              case "DistrictsSelected":
                this.DistrictsSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign(this.options, {
        keyword: this.orderProfitKeyword,
        order_code: this.codeKeyword,
      });

      this.getDistributionMAFromAPI();
    },
    resetSearch() {
      this.materialCategorySelected = [];
      this.DistrictsSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getDistributionMAFromAPI() {
      if (this.options.order_code) {
        this.loading = true;
        var options = JSON.parse(JSON.stringify(this.options));
        if (
          this.settings &&
          this.settings.report_hide_search_district_tree == 1
        ) {
          options = Object.assign(options, {
            district_id: this.districtID,
          });
        }
        OrderProfitAnalyze.fetchOne(
          Object.assign({}, options, {
            order_code: this.options.order_code,
          })
        ).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.order_profit_analyze = response.data.order_profit_details;
              this.profit_total_rate = response.data.profit_total_rate;
              this.profit_total = response.data.profit_total;
              this.sale_total = response.data.sale_total;
              this.cost_total = response.data.cost_total;
              this.paging = response.data.paging;
            } else if (response.data.error.code.isNoResultSet()) {
              this.options.page = 1;
            }
            this.loading = false;
          }.bind(this)
        );
      }
    },
    exportExcel() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      OrderProfitAnalyze.exportOne(
        this.$route.params.code,
        Object.assign({}, options, { order_code: this.options.order_code })
      );
    },
  },
  watch: {
    districtID: {
      handler() {
        this.getDistributionMAFromAPI();
      },
    },
    options: {
      deep: true,
      handler() {
        this.getDistributionMAFromAPI();
        sessionStorage.setItem(
          "order_profit_analyze-options",
          JSON.stringify(this.options)
        );
      },
    },
    // 商品分类
    materialCategorySelected: {
      handler() {
        this.options.category_ids = this.materialCategorySelected.map(
          (category) => category.id
        );
        sessionStorage.setItem(
          "order_profit_analyze-materialCategorySelected",
          JSON.stringify(this.materialCategorySelected)
        );
      },
    },
    DistrictsSelected: {
      handler() {
        if (
          this.settings &&
          this.settings.report_hide_search_district_tree == 2
        ) { 
          this.options.district_ids = this.DistrictsSelected
            ? this.DistrictsSelected.map((e) => {
              return e.id;
            })
            : [];
          sessionStorage.setItem(
            "order_profit_analyze-DistrictsSelected",
            JSON.stringify(this.DistrictsSelected)
          );
        }
      },
    },
  },
};
</script>

<style>
</style>
